// src/pages/Login.js

import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Login.css';
import GoogleLogin from '../components/GoogleLogin';
import logo from '../assets/logo-leilancer.png';

import { safeReturnPath } from '../utils/sessionExpiry';

function Login() {
  const location = useLocation();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [erro, setErro] = useState('');
  const API_URL = process.env.REACT_APP_API_URL;

  const finalizarLogin = (data) => {
      sessionStorage.setItem('token', data.token);
      sessionStorage.setItem('user', JSON.stringify(data.user));
      // Admin/moderador vão pro painel administrativo; usuário comum pro /dashboard.
      // Full reload (window.location) em vez de navigate: garante que o
      // AuthContext remonte com o usuário CERTO — sem isso, um login logo após
      // um logout podia herdar o role anterior do contexto em memória.
      const role = data.user?.role || 'usuario';
      const destino = role==='educacao'?'/admin/educacao/produtos':['admin', 'moderador'].includes(role) ? '/admin/dashboard' : '/dashboard';
      const from = location.state?.from;
      const retorno = safeReturnPath(from ? from.pathname + (from.search || '') + (from.hash || '') : sessionStorage.getItem('loginReturnTo'));
      sessionStorage.removeItem('loginReturnTo');
      window.location.assign(role==='educacao'?destino:(retorno || destino));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setErro('');

    try {
      const res = await axios.post(`${API_URL}/api/auth/login`, { email, password });
      finalizarLogin(res.data);
    } catch (err) {
      setErro('Email ou senha inválidos');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <form onSubmit={handleLogin} className="login-form">
          <h2>Login</h2>
          {new URLSearchParams(location.search).get('motivo') === 'sessao-expirada' && <p role="status">Sua sessão expirou. Entre novamente para continuar de onde parou.</p>}

          <GoogleLogin onSuccess={finalizarLogin} />
          <p className="separator">Ou use seu email de login:</p>

          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <a href="#" className="forgot-link">Esqueceu a senha?</a>

          {/* Captcha pode ser implementado futuramente */}

          {erro && <p className="erro-texto">{erro}</p>}

          <button type="submit" className="login-submit">LOGIN</button>
        </form>

        <div className="login-side">
          <img src={logo} alt="Leilancer" className="side-logo" />
          <h3>Não Possui Cadastro?</h3>
          <p>Clique no botão abaixo e crie sua conta agora mesmo</p>
          <p>E tenha acesso a ferramentas exclusivas</p>
          <button className="cadastro-btn" onClick={() => navigate('/register')}>CADASTRO</button>
        </div>
      </div>
    </div>
  );
}

export default Login;
